/**
 * ValidationRefundNotice — Mention obligatoire de transparence affichée à
 * chaque étape du parcours d'adhésion spécialiste.
 *
 * Emplacements (cf. spec produit) :
 *   • page Tarifs (présentation abonnements)
 *   • page Paiement / récapitulatif de commande
 *   • email de confirmation (côté backend)
 *   • espace personnel spécialiste tant que statut = "pending"
 *   • formulaire d'inscription spécialiste
 *
 * Variantes :
 *   - variant="banner"   → encart en haut de section (par défaut)
 *   - variant="inline"   → texte court intégré au fil du contenu
 *   - variant="compact"  → version 2 lignes pour les récap commande
 */
import { ShieldCheck, AlertCircle } from "lucide-react";

const MESSAGE = (
  "Votre demande d'adhésion est soumise à validation par CONFILEX. Le règlement effectué " +
  "lors de l'inscription constitue une demande d'adhésion. L'abonnement ne devient définitif " +
  "qu'après validation de votre candidature. En cas de refus, l'intégralité des sommes versées " +
  "sera remboursée automatiquement."
);

export default function ValidationRefundNotice({ variant = "banner", className = "" }) {
  if (variant === "inline") {
    return (
      <p
        data-testid="validation-refund-notice-inline"
        className={`text-xs text-slate-600 leading-relaxed ${className}`}
      >
        <ShieldCheck className="w-3 h-3 text-emerald-600 inline-block mr-1 -mt-0.5" />
        {MESSAGE}
      </p>
    );
  }
  if (variant === "compact") {
    return (
      <div
        data-testid="validation-refund-notice-compact"
        className={`flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50/60 p-3 text-[12px] text-amber-900 leading-snug ${className}`}
      >
        <AlertCircle className="w-3.5 h-3.5 mt-0.5 shrink-0 text-amber-700" />
        <span>
          Adhésion soumise à validation CONFILEX. En cas de refus, remboursement intégral automatique.
        </span>
      </div>
    );
  }
  // banner (default)
  return (
    <div
      data-testid="validation-refund-notice"
      className={`rounded-xl border-l-4 border-[#C9A961] bg-[#FAF7F1] p-4 ${className}`}
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-lg bg-white border border-[#E8DCC0] flex items-center justify-center shrink-0">
          <ShieldCheck className="w-4 h-4 text-[#8A6E3A]" />
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-[#8A6E3A] font-medium mb-1">
            Référencement soumis à validation préalable
          </p>
          <p className="text-sm text-slate-700 leading-relaxed">{MESSAGE}</p>
        </div>
      </div>
    </div>
  );
}
